import { getStorageSafely as getStorageSafelyUtils } from '@seeqdev/utils';

/**
 * Provides access to a form of browser storage.  localStorage if available, otherwise sessionStorage.  Allows support
 * for browsers with localStorage disabled and in a form that is easily mocked.
 * @deprecated Use getStorageSafely from @seeqdev/utils instead.
 */
export function getStorageSafely() {
  return getStorageSafelyUtils();
}
